import React, { useState } from "react";
import { string, object } from "prop-types";
import classNames from "classnames/bind";
// eslint-disable-next-line import/no-cycle
import { FluidSections } from "../FluidSections";
import * as styles from "./FluidCollapsibleComponent.module.scss";

const cx = classNames.bind(styles);

const FluidCollapsibleComponent = ({
	sectionHeading,
	buttonText,
	fluidContentSections,
	locale,
}) => {
	const [isVisible, setIsVisible] = useState(true);

	let stateClasses = "";
	let toggledButtonClassed = "";

	if (isVisible === true) {
		stateClasses = "";
		toggledButtonClassed = "";
	} else {
		stateClasses = cx("isHidden");
		toggledButtonClassed = cx("buttonToggled", "buttonToggledCustom");
	}

	return (
		<div
			className={cx(
				"fluidCollapsibleComponentContainer",
				"fluidCollapsibleComponentContainerCustom"
			)}>
			<div
				className={cx(
					"fluidCollapsibleComponentContainerNav",
					"fluidCollapsibleComponentContainerNavCustom"
				)}>
				{sectionHeading && (
					<h2
						className={cx(
							"fluidCollapsibleComponentContainerHeading",
							"fluidCollapsibleComponentContainerHeadingCustom"
						)}>
						{sectionHeading}
					</h2>
				)}
				<button
					type="button"
					className={cx(
						"fluidCollapsibleComponentContainerToggleButtons",
						"fluidCollapsibleComponentContainerToggleButtonsCustom",
						"buttonClean",
						toggledButtonClassed
					)}
					onClick={() => setIsVisible(!isVisible)}>
					{buttonText && buttonText}
				</button>
			</div>
			{fluidContentSections && (
				<div className={cx("componentContainer", "componentContainerCustom", stateClasses)}>
					<FluidSections data={fluidContentSections} locale={locale} />
				</div>
			)}
		</div>
	);
};

FluidCollapsibleComponent.propTypes = {
	sectionHeading: string,
	buttonText: string.isRequired,
	fluidContentSections: object,
	locale: string,
};
FluidCollapsibleComponent.defaultProps = {
	sectionHeading: null,
	fluidContentSections: [],
	locale: null,
};

export default FluidCollapsibleComponent;
export { FluidCollapsibleComponent };
